import { useEffect, useState } from "react";
import { sendMessage } from "../utils/webSocket";
import { sanitizeText } from "../../../../js/utils/functions";

export const useLiveSessionWSChat = ({
  chatMessages$,
  isWebSocketConnected,
  jwt,
  user,
  currentUserId,
  teacherId,
  webSocketConfig,
} = {}) => {
  const [chatWSConfig, setChatWSConfig] = useState();

  const setupChatWS = () => {
    const lsChatChannel = webSocketConfig.chatChannel.channelName;
    return {
      channels: [
        {
          channelName: lsChatChannel,
        },
      ],
      messagesListener: {
        [lsChatChannel]: ({ message, publisher, timetoken } = {}) => {
          chatMessages$.notify({
            message,
            isOwnMessage: `${currentUserId}` === `${publisher}`,
            isTeacherMessage: `${teacherId}` === `${publisher}`,
            timetoken,
          });
        },
      },
    };
  };

  const subscribeChat = async () => {
    const { channels, messagesListener } = setupChatWS();
    setChatWSConfig({
      channels,
      messagesListener,
    });
  };

  const send = async ({ message }) => {
    return sendMessage({
      channelName: webSocketConfig.chatChannel.channelName,
      message: {
        body: sanitizeText(message),
        author: user.permalink,
        avatar: user.avatar,
        jwt,
      },
      options: {
        sendByPost: true,
      },
    });
  };

  useEffect(() => {
    if (isWebSocketConnected) {
      subscribeChat();
    }
  }, [isWebSocketConnected]);

  return {
    sendMessage: send,
    chatWSConfig,
  };
};
